import { client } from '../client';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const deleteAvatar = async (user_id: number, userRole?: string): Promise<void> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  await client.delete(`${prefix}/users/${user_id}/avatar`);
};
